<template>
    <v-layout class="justify-space-between">
        <v-btn v-for="btn in buttons" :key="btn.value" :name="btn.name" :id="btn.name"
               class="box_button flex mx-auto"
               :class="classActivated(btn.value)"
               @click="$emit('input', btn.value)">
            <v-col>
                <v-row>
                    <v-icon class="mx-auto mb-1">{{ btn.icon }}</v-icon>
                </v-row>
                {{ btn.text }}
            </v-col>
        </v-btn>
    </v-layout>
</template>

<script>
  import { FormasPagamento } from '@/plugins/constants'

  const { Cartao, Boleto, Link } = FormasPagamento

  export default {
    name: 'FormaToggle',
    props: {
      value: { type: String, validators: [Cartao, Boleto, Link] },
      cartao: Boolean,
      boleto: Boolean,
      link: Boolean,
      multiplasCotas: { type: Boolean, default: false },
      pagamentoAtual: {
        type: String, default: null
      }
    },
    computed: {
      buttons () {
        let allButtons = []
        if (!this.multiplasCotas) {
          allButtons.push({ name: 'cartao', value: Cartao, icon: 'rod-cartao', text: 'Cartão' })
        }
        allButtons.push({ name: 'boleto', value: Boleto, icon: 'rod-boleto', text: 'Boleto' })
        if (!this.multiplasCotas) {
          allButtons.push({ name: 'link', value: Link, icon: 'rod-email', text: 'Link por e-mail *' })
        }
        let availableButtons = allButtons
        if (this.pagamentoAtual && !this.multiplasCotas) {
          availableButtons = allButtons.filter(b => b.name !== this.pagamentoAtual)
        }
        return availableButtons.filter(b => this[b.name])
      }
    },
    methods: {
      classActivated (value) {
        return this.value === value ? 'accent text--white' : 'white text--gray'
      }
    }
  }
</script>

<style lang="scss" scoped>
    .box_button {
        height: 100px !important;
        max-width: 150px;
        border: solid 1px var(--gray) !important;
    }
</style>
